module.exports = __webpack_public_path__ + "896415b88edb632611156b0849266428.woff";